import AuthRegister from './Register';

export default AuthRegister;
